import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { deviceMatchingService } from './deviceMatchingService';

// إنشاء مثيل من FingerprintJS مع إعدادات مخصصة
const fpPromise = FingerprintJS.load();

/**
 * خدمة للتعامل مع بصمة الجهاز
 */
export const fingerprintService = {
  /**
   * الحصول على بصمة الجهاز
   * @returns {Promise<string>} بصمة الجهاز
   */
  async getFingerprint() {
    try {
      // انتظار تحميل المكتبة
      const fp = await fpPromise;
      
      // الحصول على بصمة الجهاز
      const result = await fp.get();
      
      // إرجاع البصمة كنص
      return result.visitorId;
    } catch (error) {
      console.error('Error getting device fingerprint:', error);
      return null;
    }
  },

  /**
   * الحصول على البصمة الموسعة للجهاز
   * @returns {Promise<Object>} البصمة الموسعة
   */
  async getEnhancedFingerprint() {
    try {
      const fingerprint = await this.getFingerprint();
      return deviceMatchingService.createEnhancedFingerprint(fingerprint);
    } catch (error) {
      console.error('Error getting enhanced fingerprint:', error);
      return null;
    }
  },

  /**
   * الحصول على معلومات الجهاز
   * @returns {Promise<Object>} معلومات الجهاز
   */
  async getDeviceInfo() {
    try {
      // الحصول على معلومات المتصفح
      const browserInfo = {
        type: this.getDeviceType(),
        os: this.getOperatingSystem(),
        browser: this.getBrowserInfo(),
        region: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
      };
      
      return browserInfo;
    } catch (error) {
      console.error('Error getting device info:', error);
      return {};
    }
  },

  /**
   * الحصول على نوع الجهاز
   * @returns {string} نوع الجهاز (Desktop, Mobile, Tablet)
   */
  getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipod|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(userAgent);
    const isTablet = /ipad|android(?!.*mobile)|tablet|kindle|playbook|silk|(?=.*android)(?=.*mobile)/i.test(userAgent);
    
    if (isMobile) return 'Mobile';
    if (isTablet) return 'Tablet';
    return 'Desktop';
  },

  /**
   * الحصول على نظام التشغيل
   * @returns {string} نظام التشغيل
   */
  getOperatingSystem() {
    const userAgent = navigator.userAgent;
    let os = 'Unknown';
    
    if (/Windows/i.test(userAgent)) os = 'Windows';
    else if (/Macintosh|Mac OS X/i.test(userAgent)) os = 'MacOS';
    else if (/Linux/i.test(userAgent)) os = 'Linux';
    else if (/Android/i.test(userAgent)) os = 'Android';
    else if (/iPhone|iPad|iPod/i.test(userAgent)) os = 'iOS';
    
    return os;
  },

  /**
   * الحصول على معلومات المتصفح
   * @returns {string} اسم المتصفح
   */
  getBrowserInfo() {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';
    
    if (/Chrome/i.test(userAgent)) browser = 'Chrome';
    else if (/Firefox/i.test(userAgent)) browser = 'Firefox';
    else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) browser = 'Safari';
    else if (/Edge/i.test(userAgent)) browser = 'Edge';
    else if (/Opera|OPR/i.test(userAgent)) browser = 'Opera';
    else if (/MSIE|Trident/i.test(userAgent)) browser = 'Internet Explorer';
    
    return browser;
  }
};
